<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tcI6YX/tc-custom/9781452148076.jpg?1694759727615" alt="This image is the cover for the book Why Boys Need Parents"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Why Boys Need Parents
      </h1>
      <p class="bookDescription body article font2">
        <b>Hilarious photos of mishaps and messes that remind us why boys need adult supervision . . .</b><br/>  <br/> Boys will be boys. Unfortunately, they will also be arsonists, wrecking balls, and eight-limbed ninjas of destruction. Their impulse to experiment and explore has given us electricity, space exploration, and the polio vaccine. It has also given us Chernobyl, telemarketing, and countless bathroom floods. With photos pulled from the 1950s on, this book celebrates the wacky, illogical, dangerous, and ridiculous things boys do. Moms and dads everywhere will laugh in recognition at each bit of mischief and misadventure—proof that boys really do need parents. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alex Beckerman
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6b610818